const { createSlice } = require('@reduxjs/toolkit');

const HeaderSlice = createSlice({
    name: 'Header',
    initialState: {
        CheckSidebarOpen: true, /// initial payment Gateway Open
        CheckMobileSidebarOpen: false,
    },
    reducers: {
        CheckSideBarAction(state, action) {
            state.CheckSidebarOpen = action.payload
        },
        MobileSidebarSideBarAction(state, action) {
            state.CheckMobileSidebarOpen = action.payload
        },
    },
});

export const { CheckSideBarAction,MobileSidebarSideBarAction } = HeaderSlice.actions;
export default HeaderSlice.reducer;

// export function ResetPasswordAction(data) {
//     return async function ResetPasswordThunk(dispatch, getState) {
//         dispatch(CheckSideBarAction(data));
//     }
// }
